<ion-header>
  <ion-toolbar>
    <ion-title> Please Confirm </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeFunction()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="confirm-wrapper">
    <div *ngIf="photo">
      <img [src]="getPhotoUrl(photo)" alt="Image To Delete">
    </div>
    <p>
      Are you sure you want to delete <br />
      {{ name || 'Unnamed' }}?
    </p>
    <div class="button-wrapper">
      <button type="button" class="cnt-button confirm-delete" (click)="deleteFunction()">
        <div class="cnt-button-copy">Yes</div>
      </button>
      <button type="button" class="cnt-button cancel-delete" (click)="closeFunction()">
        <div class="cnt-button-copy">No</div>
      </button>
    </div>
  </div>
</ion-content>
